import React, { Component } from 'react';

class RadioButtonPermisos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checked1: false,
            checked2: false
        }
    }

    selected(Id) {
        if (Id == 1) {
            if(this.state.checked1)
                this.setState({ checked1: false, checked2: false });
            else
                this.setState({ checked1: true, checked2: false });
        }
        else {
            if(this.state.checked2)
                this.setState({ checked1: false, checked2: false });
            else
                this.setState({ checked1: false, checked2: true });
        }

        this.props.onChangeRadio(Id);
    }

    render() {
        const { props } = this;

        let _funcionalidades = false;
        let _Producto = "";
        let _Categoria = "";
        let _Programa = "";

        if (props.data.filter.product != 0 && props.data.filter.category != 0 && props.data.filter.program != 0) {
            _funcionalidades = true;
            _Producto = props.data.productos.find(x => x.Id == props.data.filter.product);
            _Categoria = props.data.categorias.find(x => x.Id == props.data.filter.category);
            _Programa = props.data.programas.find(x => x.Id == props.data.filter.program);
        }

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">...tiene en</label>
                    </div>
                </div>
                <div className="row row-radio">
                    <div className="col-xs-12">
                        <div className="container-radio radio-margin">
                            <input id="1" type="radio" name="first" checked={this.state.checked1} />
                            <label className="lbl-radio label-secondary" onClick={() => this.selected(1)}>
                                Todos los productos, categorías y programas
                            </label>
                        </div>
                    </div>
                </div>
                {_funcionalidades ?
                    <div className="row row-radio">
                        <div className="col-xs-12">
                            <div className="container-radio radio-margin">
                                <input id="2" type="radio" name="first" checked={this.state.checked2} />
                                <label className="lbl-radio label-secondary" onClick={() => this.selected(2)}>
                                    {_Producto.Descripcion}
                                    <span className="ti-angle-right"></span>
                                    {_Categoria.Descripcion}
                                    <span className="ti-angle-right"></span>
                                    {_Programa.Descripcion}
                                </label>
                            </div>
                        </div>
                    </div> : null}
            </div>
        );
    }
}

export default RadioButtonPermisos;